var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chegada-do-aviao",
    d: "M2.278,7.685a6.024,6.024,0,0,0,3.368,4.764l12.862,6.313A2.436,2.436,0,0,0,21.79,17.54a2.5,2.5,0,0,0-1.275-3.287L17.052,12.52,15.38,3.529a2.5,2.5,0,0,0-1.5-2.069l-.793-.338A1.5,1.5,0,0,0,11,2.505V9.492L6.933,7.457,5.67,4.226A1.925,1.925,0,0,0,3.761,3.018a1.815,1.815,0,0,0-1.285.656A2.024,2.024,0,0,0,2.012,5.19l.267,2.495ZM12,2.5a.5.5,0,0,1,.7-.461l.791.337a1.521,1.521,0,0,1,.9,1.287l1.541,8.294L12,9.993V2.5ZM3.239,4.319a.968.968,0,0,1,.642-.3.912.912,0,0,1,.857.576L6.071,8a.506.506,0,0,0,.242.265l13.765,6.888.022.011a1.5,1.5,0,0,1,.773,1.976,1.436,1.436,0,0,1-1.928.723L6.083,11.549A5.019,5.019,0,0,1,3.272,7.578l-.267-2.5a1.026,1.026,0,0,1,.233-.764ZM24,23.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1,0-1h23A.5.5,0,0,1,24,23.5Z",
    transform: "translate(0 -1.002)",
    fill: "#35bde8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneBack);
export default __webpack_public_path__ + "static/media/plane-back.a03570f94d9c55406d813e291f3a8119.svg";
export { ForwardRef as ReactComponent };